export const environment = {
  production: false,
  environmentName: 'staging',
  apiUrl: 'https://api-coripet.gridsig.com',
  origin: 'coripet.gridsig.com',
  s3Url: 'https://coripet.gridsig.com'
};
